/* ============================================================
   HF DESIGNS — Blackout (Final)
   Mobile menu, scroll reveals, card tilt, quick add,
   AJAX cart drawer, variant picker, accordions, marquee.
   Theme-editor aware: re-inits on shopify:section:load.
   ============================================================ */
(function () {
  'use strict';

  var CONFIG = window.HF || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------------- Money formatting ---------------- */
  function formatMoney(cents, format) {
    var fmt = format || CONFIG.moneyFormat || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function thousands(number, precision, thousandsSep, decimalSep) {
      if (isNaN(number) || number === null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (thousandsSep || ','));
      var cts = parts[1] ? (decimalSep || '.') + parts[1] : '';
      return dollars + cts;
    }

    var match = fmt.match(placeholder);
    switch (match && match[1]) {
      case 'amount': value = thousands(cents, 2); break;
      case 'amount_no_decimals': value = thousands(cents, 0); break;
      case 'amount_with_comma_separator': value = thousands(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = thousands(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = thousands(cents, 2, "'", '.'); break;
      default: value = thousands(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  function sized(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str == null ? '' : str;
    return d.innerHTML;
  }

  function t(key, fallback) {
    return (CONFIG.strings && CONFIG.strings[key]) || fallback;
  }

  /* ---------------- Loading bar ---------------- */
  var loadingBar = document.createElement('div');
  loadingBar.className = 'loading-bar';
  document.body.appendChild(loadingBar);

  function showLoading() {
    loadingBar.style.width = '70%';
    loadingBar.classList.add('is-active');
  }
  function hideLoading() {
    loadingBar.style.width = '100%';
    setTimeout(function () {
      loadingBar.style.width = '0';
      loadingBar.classList.remove('is-active');
    }, 280);
  }

  /* ---------------- Toast ---------------- */
  var toastEl = null;
  var toastTimer = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* ---------------- Header ---------------- */
  window.addEventListener('scroll', function () {
    var header = document.querySelector('.site-header');
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 16);
  }, { passive: true });

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var nav = document.querySelector('.site-nav');
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------------- Scroll reveal ---------------- */
  var revealObserver = null;
  if ('IntersectionObserver' in window) {
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
  }

  function initReveals(root) {
    (root || document).querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) {
      if (revealObserver) revealObserver.observe(el);
      else el.classList.add('is-visible');
    });
  }

  /* ---------------- Product card tilt + lift ---------------- */
  function initTilt(root) {
    if (document.body.getAttribute('data-tilt') === 'false') return;
    if (window.matchMedia('(hover: none)').matches) return;

    (root || document).querySelectorAll('.product-card:not([data-tilt-bound])').forEach(function (card) {
      card.setAttribute('data-tilt-bound', 'true');
      var media = card.querySelector('.product-card__media');

      card.addEventListener('mouseenter', function () { card.classList.add('is-lift'); });
      card.addEventListener('mouseleave', function () {
        card.classList.remove('is-lift');
        if (media) media.style.transform = '';
      });

      if (!media) return;
      card.addEventListener('mousemove', function (e) {
        var rect = media.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var rotateX = ((y - rect.height / 2) / (rect.height / 2)) * -6;
        var rotateY = ((x - rect.width / 2) / (rect.width / 2)) * 6;
        media.style.transform = 'perspective(800px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
      });
    });
  }

  /* ---------------- FAQ / accordions ---------------- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.faq__q');
    if (!q) return;
    var item = q.closest('.faq__item');
    var group = item.closest('[data-faq]');
    var panel = item.querySelector('.faq__a');
    var wasOpen = item.classList.contains('is-open');

    if (group && group.getAttribute('data-faq-single') === 'true') {
      group.querySelectorAll('.faq__item').forEach(function (other) {
        other.classList.remove('is-open');
        var p = other.querySelector('.faq__a');
        if (p) p.style.maxHeight = '0px';
        var btn = other.querySelector('.faq__q');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }

    if (!wasOpen) {
      item.classList.add('is-open');
      q.setAttribute('aria-expanded', 'true');
      if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
    } else {
      item.classList.remove('is-open');
      q.setAttribute('aria-expanded', 'false');
      if (panel) panel.style.maxHeight = '0px';
    }
  });

  /* ---------------- Announcement rotator ---------------- */
  function initAnnouncement(root) {
    (root || document).querySelectorAll('[data-announcement]:not([data-ann-bound])').forEach(function (bar) {
      bar.setAttribute('data-ann-bound', 'true');
      var slides = bar.querySelectorAll('.announcement__slide');
      if (slides.length < 2) return;
      var speed = parseInt(bar.getAttribute('data-speed'), 10) || 5;
      var i = 0;
      setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, speed * 1000);
    });
  }

  /* ---------------- Video cover ---------------- */
  document.addEventListener('click', function (e) {
    var cover = e.target.closest('.video-cover');
    if (!cover) return;
    var wrap = cover.closest('.video-wrap');
    var src = cover.getAttribute('data-video-src');
    if (src && wrap) {
      var iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('title', cover.getAttribute('data-video-title') || 'Video');
      wrap.appendChild(iframe);
    } else if (wrap) {
      var v = wrap.querySelector('video');
      if (v) v.play();
    }
    cover.remove();
  });

  /* ---------------- PDP gallery ---------------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var main = document.querySelector('[data-main-image]');
    if (main) {
      main.src = thumb.getAttribute('data-src');
      main.srcset = '';
    }
    document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* ---------------- Quantity steppers ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var box = btn.closest('[data-qty-box]');
    if (!box) return;
    var input = box.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val += btn.getAttribute('data-qty-step') === 'up' ? 1 : -1;
    input.value = Math.max(1, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Variant picker ---------------- */
  function ProductForm(section) {
    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;

    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    if (!product || !product.variants) return;

    var form = section.querySelector('[data-product-form]');
    var idInput = section.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-price]');
    var atc = section.querySelector('[data-atc]');
    var atcLabel = atc ? atc.querySelector('[data-atc-label]') : null;
    var stockNote = section.querySelector('[data-stock-note]');
    var mainImage = section.querySelector('[data-main-image]');
    var select = section.querySelector('[data-variant-select]');

    function currentSelections() {
      var out = [];
      section.querySelectorAll('[data-option-index]').forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var chosen = group.querySelector('.variant-pill.is-selected');
        out[idx - 1] = chosen ? chosen.getAttribute('data-option-value') : null;
      });
      return out;
    }

    function findVariant(selections) {
      return product.variants.find(function (v) {
        return selections.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }

    function markUnavailable(selections) {
      section.querySelectorAll('[data-option-index]').forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        group.querySelectorAll('.variant-pill').forEach(function (pill) {
          var test = selections.slice();
          test[idx - 1] = pill.getAttribute('data-option-value');
          var exists = product.variants.some(function (v) {
            return test.every(function (val, i) { return val === null || v.options[i] === val; }) && v.available;
          });
          pill.classList.toggle('is-unavailable', !exists);
        });
      });
    }

    function apply(variant) {
      if (!variant) {
        if (atc) { atc.disabled = true; }
        if (atcLabel) atcLabel.textContent = t('unavailable', 'Unavailable');
        return;
      }
      if (idInput) idInput.value = variant.id;

      if (priceEl) {
        var html = '<span class="price__current">' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
          priceEl.classList.add('price--sale');
        } else {
          priceEl.classList.remove('price--sale');
        }
        priceEl.innerHTML = html;
      }

      if (atc) {
        atc.disabled = !variant.available;
        if (atcLabel) atcLabel.textContent = variant.available ? t('addToCart', 'Add to cart') : t('soldOut', 'Sold out');
      }

      if (stockNote) {
        var threshold = parseInt(stockNote.getAttribute('data-threshold'), 10) || 0;
        var qty = variant.inventory_quantity;
        var tracked = variant.inventory_management !== null && variant.inventory_management !== undefined;
        if (threshold > 0 && tracked && qty > 0 && qty <= threshold) {
          stockNote.textContent = t('onlyLeft', 'Only {{ count }} left').replace('{{ count }}', qty);
          stockNote.hidden = false;
        } else {
          stockNote.hidden = true;
        }
      }

      if (mainImage && variant.featured_image && variant.featured_image.src) {
        mainImage.src = sized(variant.featured_image.src, 1200);
        mainImage.srcset = '';
      }

      var sticky = document.querySelector('.sticky-atc__price');
      if (sticky) sticky.innerHTML = formatMoney(variant.price);

      if (history.replaceState && variant.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    section.addEventListener('click', function (e) {
      var pill = e.target.closest('.variant-pill');
      if (!pill) return;
      e.preventDefault();
      var group = pill.closest('[data-option-index]');
      group.querySelectorAll('.variant-pill').forEach(function (p) { p.classList.remove('is-selected'); });
      pill.classList.add('is-selected');
      var selections = currentSelections();
      markUnavailable(selections);
      apply(findVariant(selections));
    });

    if (select) {
      select.addEventListener('change', function () {
        var variant = product.variants.find(function (v) { return String(v.id) === select.value; });
        apply(variant);
      });
    }

    markUnavailable(currentSelections());

    /* Sticky ATC proxies the real form */
    var stickyBtn = document.querySelector('[data-sticky-atc]');
    if (stickyBtn && form) {
      stickyBtn.addEventListener('click', function () {
        form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }
    var buyBox = section.querySelector('.buy-box');
    var stickyBar = document.querySelector('.sticky-atc');
    if (buyBox && stickyBar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
        stickyBar.setAttribute('aria-hidden', entries[0].isIntersecting ? 'true' : 'false');
      }, { threshold: 0 }).observe(buyBox);
    }
  }

  function initProductForms(root) {
    (root || document).querySelectorAll('[data-product-section]:not([data-pf-bound])').forEach(function (section) {
      section.setAttribute('data-pf-bound', 'true');
      ProductForm(section);
    });
  }

  /* ---------------- Cart ---------------- */
  var drawerEnabled = document.body.getAttribute('data-cart-drawer') === 'true';

  function openDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = drawer.querySelector('.cart-drawer__close');
    if (close) close.focus();
  }
  function closeDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  function renderDrawer(cart) {
    var badge = document.querySelector('[data-cart-count]');
    if (badge) {
      badge.textContent = cart.item_count;
      badge.classList.toggle('is-visible', cart.item_count > 0);
    }

    var body = document.getElementById('CartDrawerBody');
    var footer = document.getElementById('CartDrawerFooter');
    var total = document.getElementById('CartDrawerTotal');
    if (!body || !footer) return;

    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="cart-drawer__empty">' +
        '<p class="cart-drawer__empty-text">' + escapeHtml(t('cartEmpty', 'Your cart is empty')) + '</p>' +
        '<a href="' + ROOT + 'collections/all" class="btn btn--ghost">' + escapeHtml(t('continueShopping', 'Continue shopping')) + '</a>' +
        '</div>';
      footer.classList.remove('is-visible');
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      html += '<div class="cart-drawer__item">';
      html += '<a href="' + item.url + '" class="cart-drawer__item-img">';
      if (item.image) html += '<img src="' + sized(item.image, 160) + '" alt="' + escapeHtml(item.product_title) + '" width="80" height="80">';
      html += '</a>';
      html += '<div class="cart-drawer__item-info">';
      html += '<a href="' + item.url + '" class="cart-drawer__item-name">' + escapeHtml(item.product_title) + '</a>';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        html += '<div class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</div>';
      }
      html += '<div class="cart-drawer__item-controls">';
      html += '<div class="cart-drawer__qty">';
      html += '<button type="button" data-line-change="' + item.key + '" data-delta="-1" aria-label="Decrease quantity">\u2212</button>';
      html += '<span>' + item.quantity + '</span>';
      html += '<button type="button" data-line-change="' + item.key + '" data-delta="1" aria-label="Increase quantity">+</button>';
      html += '</div>';
      html += '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>';
      html += '</div>';
      html += '<button type="button" class="cart-drawer__item-remove" data-line-remove="' + item.key + '">' + escapeHtml(t('remove', 'Remove')) + '</button>';
      html += '</div></div>';
    });

    body.innerHTML = html;
    if (total) total.innerHTML = formatMoney(cart.total_price);
    footer.classList.add('is-visible');
  }

  function fetchCart() {
    return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function addToCart(body, isFormData) {
    showLoading();
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: isFormData ? { 'Accept': 'application/json' } : { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: isFormData ? body : JSON.stringify(body)
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Cart error');
          return data;
        });
      })
      .then(fetchCart)
      .then(function (cart) {
        renderDrawer(cart);
        hideLoading();
        if (drawerEnabled) openDrawer();
        else toast(t('addedToCart', 'Added to cart'));
        return cart;
      })
      .catch(function (err) {
        hideLoading();
        toast(err.message || t('cartError', 'Could not add to cart'));
        throw err;
      });
  }

  /* Add-to-cart form (PDP) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    if (!drawerEnabled && document.body.getAttribute('data-ajax-cart') !== 'true') return;
    e.preventDefault();
    addToCart(new FormData(form), true).catch(function () {});
  });

  /* Quick add / card add button */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = parseInt(btn.getAttribute('data-quick-add'), 10);
    if (!id) {
      window.location.href = btn.getAttribute('data-product-url') || ROOT;
      return;
    }
    addToCart({ items: [{ id: id, quantity: 1 }] }).catch(function () {
      var url = btn.getAttribute('data-product-url');
      if (url) window.location.href = url;
    });
  });

  /* Open / close drawer */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      if (!drawerEnabled) return;
      e.preventDefault();
      showLoading();
      fetchCart().then(function (cart) {
        renderDrawer(cart);
        openDrawer();
        hideLoading();
      }).catch(hideLoading);
    }
    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      closeDrawer();
    }
  });

  /* Drawer line changes */
  document.addEventListener('click', function (e) {
    var change = e.target.closest('[data-line-change]');
    var remove = e.target.closest('[data-line-remove]');
    if (!change && !remove) return;
    e.preventDefault();

    if (remove) {
      updateLine(remove.getAttribute('data-line-remove'), 0);
      return;
    }
    var key = change.getAttribute('data-line-change');
    var delta = parseInt(change.getAttribute('data-delta'), 10);
    showLoading();
    fetchCart().then(function (cart) {
      var item = cart.items.find(function (i) { return i.key === key; });
      if (!item) { hideLoading(); return; }
      updateLine(key, Math.max(0, item.quantity + delta));
    });
  });

  function updateLine(key, quantity) {
    showLoading();
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawer(cart);
        hideLoading();
        if (document.body.classList.contains('template-cart')) window.location.reload();
      })
      .catch(hideLoading);
  }

  /* ---------------- Init ---------------- */
  function initAll(root) {
    initReveals(root);
    initTilt(root);
    initAnnouncement(root);
    initProductForms(root);
  }

  initAll(document);
  window.addEventListener('load', hideLoading);

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function () { closeDrawer(); });
  document.addEventListener('shopify:block:select', function (e) {
    var faqItem = e.target.closest ? e.target.closest('.faq__item') : null;
    if (faqItem && !faqItem.classList.contains('is-open')) {
      var q = faqItem.querySelector('.faq__q');
      if (q) q.click();
    }
  });

  window.HFTheme = { formatMoney: formatMoney, openDrawer: openDrawer, closeDrawer: closeDrawer, toast: toast, init: initAll };
})();
